import { client } from './axios';
import { client as client2 } from './axios2';

const nonce = (params) => client2.get(`/login/wallet`, { params });
const login = (body) => client.post(`/login`, body);
const register = (body) => client.post(`register`, body);
const getProfile = (params) => client.get(`/account/detail`, params);
const updateProfile = (body) => client.put(`/account/detail`, body);

export const userServiceLb = {
  nonce,
  login,
  register,
  updateProfile,
  getProfile
};
